module.exports = "div.w3-card{\r\n    max-width: 500px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/change-password/change-password.component.css
// module id = ./src/app/components/change-password/change-password.component.css
// module chunks = main